import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventRcsVideoUploaded } from 'entities/Rcs/api/rcsComplianceTypes'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseEventRcsVideoUploaded) => void

export const useEventRcsVideoUploaded = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.RcsVideoUploaded, handler), [])
}
